import { bslOrgId } from "@strtmn/sds/config"
import { useContext } from "react"
import { UserDataContext } from "../contexts"

export function useIsAdmin(): boolean {
  const { userData } = useContext(UserDataContext)

  const bslOrg = userData?.Organizations.find((o) => o.id === bslOrgId)
  const userIsInBslOrg = !!bslOrg
  let isUserAdmin = false
  if (userIsInBslOrg /*&& bslOrg.userRole === "USER_ADMIN"*/) {
    isUserAdmin = true
  }
  const isAdmin = isUserAdmin // support for (more) admin roles to come

  return isAdmin
}
